import { render } from "./Month.vue?vue&type=template&id=d49c8d3e"
import script from "./Month.vue?vue&type=script&lang=js"
export * from "./Month.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__